import { createContainer } from 'unstated-next'
import { useState } from 'react'

function useLangAccessCodes(initialState) {
    const [langAccessCodes, setLangAccessCodes] = useState(initialState)
    return { langAccessCodes, setLangAccessCodes }
}

export default createContainer(useLangAccessCodes)
